import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import lang from '../../lib/language';

import { Button } from '../../components';
import { ButtonTypesEnum } from '../../components/Button/Button.types';
import { UI_ROUTES } from '../../util/routes';
import { DateRangeState } from '../../util/types';

import styles from './UpcomingEarnings.module.scss';

const UpcomingEarnings = () => {
  const history = useHistory();
  const range = { startDate: undefined, endDate: undefined, key: 'selection' };

  return (
    <div className={styles.wrapper}>
      <div className={styles.textWrapper}>
        <div className={styles.title}>{lang.upcomingEarnings()}</div>
        <div className={styles.text}>{lang.upcomingEarningsText()}</div>
        <Button
          variant={ButtonTypesEnum.LinkSecondary}
          onClick={() => history.push(UI_ROUTES.discover + UI_ROUTES.earningsCalendar, range)}
          className={styles.viewMoreButton}
        >
          {lang.commonViewMore()}
        </Button>
      </div>
    </div>
  );
};

export default UpcomingEarnings;
